export default {
  apexBarPorEstado: {
    series: [
      {
        name: "Pessoas",
        data: [], // serão preenchidos dinamicamente
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      colors: ["#536dfe"],
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: "14px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [],
        labels: {
          formatter: function(value) {
            return value;
          },
        },
      },
      yaxis: {
        //max: 20,
        title: {
          text: "Número de Pessoas por Estado",
        },
        labels: {
          formatter: function(value) {
            return value;
          },
        },
      },
      tooltip: {
        intersect: false,
        x: {
          formatter: function(value) {
            return value;
          },
        },
      },
    },
  },
  apexPiePorEstado1: {
    series: [44, 55, 13, 43, 22],
    options: {
      chart: {
        type: "pie",
      },
      theme: {
        monochrome: {
          enabled: false,
        },
      },
      //labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  },

  apexBarPorGenero: {
    series: [
      {
        name: "Pessoas",
        data: [], // serão preenchidos dinamicamente
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      colors: ["#536dfe"],
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: "14px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [],
        title: {
          text: "Número de Pessoas por Gênero",
        },
        labels: {
          formatter: function(value) {
            return value;
          },
        },
      },
      yaxis: {
        //max: 20,
        title: {
          text: "",
        },
        labels: {
          formatter: function(value) {
            return value;
          },
        },
      },
      tooltip: {
        intersect: false,
        x: {
          formatter: function(value) {
            return value;
          },
        },
      },
    },
  },
  apexPiePorGenero: {
    series: [44, 55, 13, 43, 22],
    options: {
      chart: {
        type: "pie",
      },
      theme: {
        monochrome: {
          enabled: false,
        },
      },
      //labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  },

  apexBarPorIdade: {
    series: [
      {
        name: "Pessoas",
        data: [], // serão preenchidos dinamicamente
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      colors: ["#536dfe"],
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: "14px",
          colors: ["#304758"],
        },
      },
      xaxis: {
        categories: [],
        labels: {
          formatter: function(value) {
            return value;
          },
        },
      },
      yaxis: {
        //max: 20,
        title: {
          text: "Número de Pessoas por Faixa Etária",
        },
        labels: {
          formatter: function(value) {
            return value;
          },
        },
      },
      tooltip: {
        intersect: false,
        x: {
          formatter: function(value) {
            return value;
          },
        },
      },
    },
  },
};
